import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The Willows",
  "description": "",
  "published": "2007-06-11T00:00:00.000Z",
  "redirect_from": ["/blog/the-willows/swizec/191"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Heh, pripovedovanje vsega, kar je treba povedati si je iz kronosa vzelo veÄji presledek od priÄakovanega. Vseeno, naprej na našem poslanstvu za svetovno prevlado.`}</p>
    <p><a parentName="p" {...{
        "href": "http://thewillowsmagazine.com/"
      }}>{`The Willows`}</a>{` je revija, ki je pred nedavnim izdala svojo prvo inkarnacijo in naroÄil sem jo še isti dan. Na Å¾alost je njen prihod trajal nekaj veÄ Äasa zaradi nekakšne napake na njihovem koncu in ker, kot kaÅ¾e, sistem za pošiljanje sploh še ni bil vzpostavljen, ko so naroÄila Å¾e sprejemali. Ampak ne zamerim jim, tako ali tako nisem imel Äasa brata niti, ko je konÄno prispela.`}</p>
    <p>{`Izdaja se je ponašala s Äudovito Ärno zunanjostjo z belimi slikarijami in pisarijo in je s svojim pogledom instantno privlaÄila. Branje me je popeljalo naravnost nazaj v dni Lovecrafta in Poeja, Äeprav Poe teoretiÄno ne spada v ta Å¾anr. Zgodbe so predstavljale prav prijeten izbor, moji komplimenti uredniku. Dodatek kratkih poudarjenih citatov v telo zgodbe na vsaki strani je revijo prijetno poÅ¾ivil in ji pridal tisti duh po poznem 19. stoletju.`}</p>
    <p>{`Najbolj mi je bil pri srcu dodatek ene ali dveh izmišljenih reklam, ki so Äasovnemu obdobju odliÄno pristajale. Pristanek na teh straneh je resniÄno polepšal moj dan, saj so bile postavljene v parodiÄen ton reklam, ki bi jih taka revija resniÄno lahko vsebovala. V konÄni fazi je bila revija prijetna oÅ¾ivitev pozabljenega Å¾anra; druga izdaja bo zagotovo romala v moj poštni nabiralnik. PriporoÄam vsem, da si priskrbijo svojo.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      